import React from 'react'
import { useNavigate } from 'react-router-dom'

import styles from './AppTile.module.scss'

import Heading from 'Design/components/Heading'

const AppTile = (props) => {
  const { name, description, brandImage } = props
  const navigate = useNavigate()

  const handleClick = () => {
    navigate(props.app_type)
  }

  return (
    <div className={styles.Tile} onClick={handleClick}>
      <div className={styles.BrandImageContainer}>
        <img src={brandImage} alt={name} title={name} className={styles.BrandImage} />
      </div>
      <Heading level={2}>{name}</Heading>
      <p className={styles.AppDescription}>{description}</p>
    </div>
  )
}

export default AppTile
